<template>
  <div>
    <el-dialog
        class="linkLetter"
        :title="title"
        :visible.sync="letterVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        width="30%">
      <div>
        <el-alert
            :title="tipTitle"
            type="info"
            :closable="false">
        </el-alert>

        <div class="weblinkLetter">
          <el-form label-position="top" label-width="80px" :model="data">
            <el-form-item :label="phoneLabel">
              <el-input v-model="data.phone"></el-input>
            </el-form-item>
            <el-form-item :label="contentLabel">
              <el-input
                  type="textarea"
                  rows="4"
                  :placeholder="contentPlaceholder"
                  v-model="data.content">
              </el-input>
            </el-form-item>
          </el-form>
          <el-button @click="postLetter" style="width: 100%;margin-top: 6px" type="primary">{{buttonTitle}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
name: "webLetter",
  data() {
    return {
      teamID: '',
      YQToken: '',
      beforeUrl: '',
      letterVisible: true,
      data: {
        'phone': '',
        'content':''
      },
      title: '离线请留言',
      tipTitle: '由于客服没有在线，不能提供在线服务，有问题可以给我们留言！',
      winLong: 0,
      phoneLabel: '电话',
      contentLabel: '留言内容',
      contentPlaceholder: '请输入内容',
      buttonTitle: '提交'
    }
  },

  mounted() {
    this.teamID = this.$route.query.teamID
    this.YQToken = this.$route.query.YQToken
    this.beforeUrl = this.$route.query.beforeUrl
    this.getLetterInfo()
  },

  methods:{
    //获取账号信息
    getLetterInfo()
    {
      this.$https({url: 'letterInfo?teamID='+this.teamID,method: "get"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.winLong = backData.data.data.winLong;
          if (this.winLong == 0) {
            this.title = '离线请留言'
            this.tipTitle = '由于客服没有在线，不能提供在线服务，有问题可以给我们留言！'
            this.phoneLabel = '电话'
            this.contentLabel = '留言内容'
            this.contentPlaceholder = '请输入内容'
            this.buttonTitle = '提交'
          } else {
            this.title = 'Offline, please leave a message'
            this.tipTitle = 'Due to customer service not being online, we are unable to provide online services. If you have any questions, please leave us a message！'
            this.phoneLabel = 'phone'
            this.contentLabel = 'message'
            this.contentPlaceholder = 'Please enter the content'
            this.buttonTitle = 'submit'
          }
        }
      });
    },
    postLetter()
    {
      this.data.teamID = this.teamID
      this.data.YQToken = this.YQToken
      this.$https({url: 'LeavingMsg',data:this.data,method: "post"}).then(backData => {
        if (backData.data.status === 200)
        {
          this.data = {}
          this.$notify({
            message: '留言保存成功！',
            type: 'success'
          });
        }
        if (backData.data.status === 201)
        {
          this.data = {}
          this.$notify({
            message: '留言参数不能为空！',
            type: 'warning'
          });
        }
      });
    },
    handleClose(done) {
      if (this.beforeUrl)
      {
        if (navigator.userAgent.indexOf("Firefox") !== -1 || navigator.userAgent.indexOf("Chrome") !==-1) {
          window.location.href="about:blank";
          window.close();
        } else {
          window.opener = null;
          window.open("", "_self");
          window.close();
        }
      } else {
        this.$notify({
          message: '已经是最后的页面了！',
          type: 'success'
        });
      }
    }
  },
}
</script>

<style>
.linkLetter .el-dialog__body{
  padding: 0;
}
.weblinkLetter{
  padding: 10px 20px 30px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/link/webLetter.vue